module.exports = __webpack_public_path__ + "img/20180414165947.560e443c.jpg";